export const participantTypes = [
  { _id: 0, title: "Class" },
  { _id: 1, title: "Staff" },
  { _id: 2, title: "Parents" },
  { _id: 3, title: "Students" },
];

export const reoccuringFrequency = [
  { _id: 0, title: "Daily" },
  { _id: 1, title: "Weekly" },
  { _id: 2, title: "Monthly" },
  { _id: 3, title: "Termly" },
  { _id: 3, title: "Annualy" },
];
